import layouts from '@/layout'
import Index from '@/views/pages/product/Index.vue'
import ProductForm from '@/views/pages/product/Form.vue'
import ProductList from '@/views/pages/product/List.vue'
import AdminTable from '@/views/pages/administration/adminTable/Index.vue'
import Category from '@/views/pages/administration/category/Index.vue'

export default {
	path: 'product',
	name: 'Productos',
	auth: true,
	component: Index,
	redirect: { path: '/product', name: 'Producto' },
	icon: 'package-variant',
	meta: {
		auth: true,
		nav: true,
		roles: ['admin']
	},
	children: [
		{
			path: '/list',
			name: 'Listar',
			component: ProductList,
			meta: {
				auth: true,
				nav: true,
        layout: layouts.navLeft,
        searchable: true,
				tags: ['Productos'],
				roles: ['admin'],
        icon: 'package-variant'
			}
		},
		{
      path: '/form',
      name: 'Formulario de productos',
      component: ProductForm,
      meta: {
        auth: true,
        nav: false,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['Productos'],
        roles: ['admin'],
        icon: 'package-variant'
      }
    },
    {
      path: '/category',
      name: 'Categorías',
      component: Category,
      meta: {
        nav: true,
        layout: layouts.navLeft,
        roles: ['admin'],
        icon: 'shape-outline',
      }
    },
		{
      path: '/attributes',
      name: 'Atributos',
      component: AdminTable,
      meta: {
        key: 'attributes',
        auth: true,
        nav: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['Productos'],
        roles: ['admin'],
        icon: 'package-variant'
      }
    }
	]
}
